import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { v4 as uuidv4 } from 'uuid';
import { DocumentToolBaseComponent } from "./DocumentToolBaseComponent";
import { DocumentEditorComponent } from "../documenteditor.component";
import { TextComponent } from "../Components/TextComponent";
import { Style } from "../HtmlRenderComponents";
import { Helpers } from "../Helpers/Helpers";
import { FabricHelpers } from "src/app/features/parking/parking/parkinglevels/leveleditor/fabric.js/helpers";
import { edit } from "ace-builds";

export class DocumentTextTool extends DocumentToolBaseComponent{
    
    public Styles !: Style;

    constructor(editor: DocumentEditorComponent, canvas: fabric.Canvas){
        super(editor, canvas);
    }

    public override CreateNew(canvasX : number, canvasY: number){
        const adjustedpoints = FabricHelpers.GetAdjustedXY(this.canvas, canvasX, canvasY);

        this.Styles = {
            fontSize: "12px",
            fontFamily: "Arial",
            color: "black",
            // Always use left/top positioning for newly created items so placement is deterministic.
            right: null,
            left: adjustedpoints[0] - this.editor.offsets.x,
            top: adjustedpoints[1] - this.editor.offsets.y,
            width : Helpers.convertInchesToPixels("5in"),
            height: null,
            fontWeight: "normal",
            textAlign: "left",
            boxShadow: null,
            borderRadius: null,
            borderStyle: "",
            IsLink: false,
            backgroundColor: null,
            textDecoration: null,
            fontStyle: 'normal',
            transform: null,
            zIndex: this.editor.GetNextZIndex()
        };

        var component = new TextComponent(this.editor, this.Styles , "Enter Text Here ...", null);

        this.editor.DocumentComponents.push(component);
        component.Draw(this.canvas);

        // Center the new text box on the click point (Fabric uses top-left by default).
        if (component.fabricItem) {
            const w = component.fabricItem.getScaledWidth();
            const h = component.fabricItem.getScaledHeight();
            const left = adjustedpoints[0] - (w / 2);
            const top = adjustedpoints[1] - (h / 2);
            component.fabricItem.set({ left, top });
            // IMPORTANT: Fabric hit-testing uses cached corner coords; update them after manual positioning
            // so the object is immediately clickable/dragable without requiring a full rerender.
            component.fabricItem.setCoords();

            // Persist centered position to template styles (relative to the document offsets).
            component.Styles.right = null;
            component.Styles.left = left - this.editor.offsets.x;
            component.Styles.top = top - this.editor.offsets.y;
        }

        // Persist immediately so Save doesn't drop new items.
        this.editor.ApplyZIndexOrdering();
        this.editor.canvas.renderAll();
        this.editor.RenderHtml();
        this.editor.Form.markAsDirty();
        return component;
    }
}
